/**
 * @generated SignedSource<<b4815b1c0339f4dcc7bb3e64fbbfe793>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EmployeeWorkStatus = "NOT_WORKING" | "WORKING";
export type TeamIcon = "account_hard_hat" | "account_tie" | "apple" | "baby_carriage" | "baguette" | "basket" | "bed" | "bread_slice" | "broom" | "carrot" | "cart" | "cash" | "cash_register" | "cheese" | "coffe" | "cookie" | "cupcake" | "default" | "desk_lamp" | "dolly" | "fish" | "flower" | "food" | "fork_knife" | "forklift" | "fridge" | "hamburger" | "hammer_wrench" | "laptop" | "market" | "meat" | "milk" | "pineapple" | "soda" | "sofa" | "steak" | "tshirt" | "tv" | "watermelon";
export type TodoPriority = "DEFAULT" | "HIGH" | "LOW" | "URGENT";
export type TodoStatus = "DONE" | "PENDING";
export type useTodoSetStatusMutation$variables = {
  employeeId?: string | null;
  newStatus: TodoStatus;
  todoId: string;
};
export type useTodoSetStatusMutation$data = {
  readonly todo: {
    readonly updateTodoItemStatus: {
      readonly todo: {
        readonly canChangeStatus: boolean;
        readonly id: string;
        readonly lastChangedStatusByActor: {
          readonly " $fragmentSpreads": FragmentRefs<"Avatar_actor">;
        } | null;
        readonly linkedProducts: ReadonlyArray<{
          readonly id: string;
          readonly numberOfPendingTodos: number;
        }>;
        readonly ordinal: string;
        readonly parent: {
          readonly canChangeStatus: boolean;
          readonly id: string;
          readonly status: TodoStatus;
        } | null;
        readonly status: TodoStatus;
        readonly subTodos: ReadonlyArray<{
          readonly canChangeStatus: boolean;
          readonly status: TodoStatus;
          readonly " $fragmentSpreads": FragmentRefs<"TodoListItemCompletedInfo_todo">;
        }> | null;
        readonly timeToResolvedFormatted: string | null;
        readonly " $fragmentSpreads": FragmentRefs<"TodoEditTimeline_todo" | "TodoListItemCompletedInfo_todo">;
      };
    };
  } | null;
};
export type useTodoSetStatusMutation$rawResponse = {
  readonly todo: {
    readonly updateTodoItemStatus: {
      readonly todo: {
        readonly canChangeStatus: boolean;
        readonly createdAtDate: {
          readonly storeFormattedDate: string;
        };
        readonly createdByActor: {
          readonly __typename: "ConnectActor";
          readonly __isActor: "ConnectActor";
          readonly employee: {
            readonly __typename: "Employee";
            readonly id: string;
            readonly image: {
              readonly __typename: "Image";
              readonly __isPublicAndInternalImage: "Image";
              readonly id: string;
              readonly sizes: ReadonlyArray<{
                readonly height: number;
                readonly id: string;
                readonly url: string;
                readonly urlExpiresAt: string | null;
                readonly width: number;
              }>;
              readonly thumbhash: string | null;
            } | {
              readonly __typename: "PublicImage";
              readonly __isPublicAndInternalImage: "PublicImage";
              readonly publicImageUrl: string;
            } | {
              readonly __typename: string;
              readonly __isPublicAndInternalImage: string;
            } | null;
            readonly name: string;
            readonly workStatus: EmployeeWorkStatus;
          } | null;
          readonly identifyingName: string | null;
        } | {
          readonly __typename: "GroupActor";
          readonly __isActor: "GroupActor";
          readonly employee: {
            readonly __typename: "Employee";
            readonly id: string;
            readonly image: {
              readonly __typename: "Image";
              readonly __isPublicAndInternalImage: "Image";
              readonly id: string;
              readonly sizes: ReadonlyArray<{
                readonly height: number;
                readonly id: string;
                readonly url: string;
                readonly urlExpiresAt: string | null;
                readonly width: number;
              }>;
              readonly thumbhash: string | null;
            } | {
              readonly __typename: "PublicImage";
              readonly __isPublicAndInternalImage: "PublicImage";
              readonly publicImageUrl: string;
            } | {
              readonly __typename: string;
              readonly __isPublicAndInternalImage: string;
            } | null;
            readonly name: string;
            readonly workStatus: EmployeeWorkStatus;
          } | null;
          readonly identifyingName: string | null;
          readonly user: {
            readonly __typename: "User";
            readonly id: string;
          } | null;
        } | {
          readonly __typename: "ScreenActor";
          readonly __isActor: "ScreenActor";
          readonly screen: {
            readonly id: string;
            readonly name: string;
          } | null;
        } | {
          readonly __typename: "UserActor";
          readonly __isActor: "UserActor";
          readonly storeUser: {
            readonly employee: {
              readonly id: string;
              readonly image: {
                readonly __typename: "Image";
                readonly __isPublicAndInternalImage: "Image";
                readonly id: string;
                readonly sizes: ReadonlyArray<{
                  readonly height: number;
                  readonly id: string;
                  readonly url: string;
                  readonly urlExpiresAt: string | null;
                  readonly width: number;
                }>;
                readonly thumbhash: string | null;
              } | {
                readonly __typename: "PublicImage";
                readonly __isPublicAndInternalImage: "PublicImage";
                readonly publicImageUrl: string;
              } | {
                readonly __typename: string;
                readonly __isPublicAndInternalImage: string;
              } | null;
              readonly name: string;
              readonly workStatus: EmployeeWorkStatus;
            } | null;
            readonly id: string;
            readonly user: {
              readonly email: string;
              readonly id: string;
              readonly name: string;
              readonly orgDescription: {
                readonly orgIconUri: string | null;
              } | null;
            };
          } | null;
        } | {
          readonly __typename: string;
          readonly __isActor: string;
        } | null;
        readonly id: string;
        readonly lastChangedStatusByActor: {
          readonly __typename: "ConnectActor";
          readonly __isActor: "ConnectActor";
          readonly employee: {
            readonly id: string;
            readonly image: {
              readonly __typename: "Image";
              readonly __isPublicAndInternalImage: "Image";
              readonly id: string;
              readonly sizes: ReadonlyArray<{
                readonly height: number;
                readonly id: string;
                readonly url: string;
                readonly urlExpiresAt: string | null;
                readonly width: number;
              }>;
              readonly thumbhash: string | null;
            } | {
              readonly __typename: "PublicImage";
              readonly __isPublicAndInternalImage: "PublicImage";
              readonly publicImageUrl: string;
            } | {
              readonly __typename: string;
              readonly __isPublicAndInternalImage: string;
            } | null;
            readonly name: string;
            readonly workStatus: EmployeeWorkStatus;
          } | null;
        } | {
          readonly __typename: "GroupActor";
          readonly __isActor: "GroupActor";
          readonly employee: {
            readonly id: string;
            readonly image: {
              readonly __typename: "Image";
              readonly __isPublicAndInternalImage: "Image";
              readonly id: string;
              readonly sizes: ReadonlyArray<{
                readonly height: number;
                readonly id: string;
                readonly url: string;
                readonly urlExpiresAt: string | null;
                readonly width: number;
              }>;
              readonly thumbhash: string | null;
            } | {
              readonly __typename: "PublicImage";
              readonly __isPublicAndInternalImage: "PublicImage";
              readonly publicImageUrl: string;
            } | {
              readonly __typename: string;
              readonly __isPublicAndInternalImage: string;
            } | null;
            readonly name: string;
            readonly workStatus: EmployeeWorkStatus;
          } | null;
        } | {
          readonly __typename: "ScreenActor";
          readonly __isActor: "ScreenActor";
          readonly screen: {
            readonly id: string;
            readonly name: string;
          } | null;
        } | {
          readonly __typename: "UserActor";
          readonly __isActor: "UserActor";
          readonly storeUser: {
            readonly employee: {
              readonly id: string;
              readonly image: {
                readonly __typename: "Image";
                readonly __isPublicAndInternalImage: "Image";
                readonly id: string;
                readonly sizes: ReadonlyArray<{
                  readonly height: number;
                  readonly id: string;
                  readonly url: string;
                  readonly urlExpiresAt: string | null;
                  readonly width: number;
                }>;
                readonly thumbhash: string | null;
              } | {
                readonly __typename: "PublicImage";
                readonly __isPublicAndInternalImage: "PublicImage";
                readonly publicImageUrl: string;
              } | {
                readonly __typename: string;
                readonly __isPublicAndInternalImage: string;
              } | null;
              readonly name: string;
              readonly workStatus: EmployeeWorkStatus;
            } | null;
            readonly id: string;
            readonly user: {
              readonly id: string;
              readonly name: string;
            };
          } | null;
        } | {
          readonly __typename: string;
          readonly __isActor: string;
        } | null;
        readonly linkedProducts: ReadonlyArray<{
          readonly id: string;
          readonly numberOfPendingTodos: number;
        }>;
        readonly ordinal: string;
        readonly parent: {
          readonly canChangeStatus: boolean;
          readonly id: string;
          readonly status: TodoStatus;
        } | null;
        readonly resolvedAtDate: {
          readonly storeFormattedDate: string;
        } | null;
        readonly status: TodoStatus;
        readonly subTodos: ReadonlyArray<{
          readonly canChangeStatus: boolean;
          readonly id: string;
          readonly lastChangedStatusByActor: {
            readonly __typename: "ConnectActor";
            readonly __isActor: "ConnectActor";
            readonly employee: {
              readonly id: string;
              readonly image: {
                readonly __typename: "Image";
                readonly __isPublicAndInternalImage: "Image";
                readonly id: string;
                readonly sizes: ReadonlyArray<{
                  readonly height: number;
                  readonly id: string;
                  readonly url: string;
                  readonly urlExpiresAt: string | null;
                  readonly width: number;
                }>;
                readonly thumbhash: string | null;
              } | {
                readonly __typename: "PublicImage";
                readonly __isPublicAndInternalImage: "PublicImage";
                readonly publicImageUrl: string;
              } | {
                readonly __typename: string;
                readonly __isPublicAndInternalImage: string;
              } | null;
              readonly name: string;
              readonly workStatus: EmployeeWorkStatus;
            } | null;
          } | {
            readonly __typename: "GroupActor";
            readonly __isActor: "GroupActor";
            readonly employee: {
              readonly id: string;
              readonly image: {
                readonly __typename: "Image";
                readonly __isPublicAndInternalImage: "Image";
                readonly id: string;
                readonly sizes: ReadonlyArray<{
                  readonly height: number;
                  readonly id: string;
                  readonly url: string;
                  readonly urlExpiresAt: string | null;
                  readonly width: number;
                }>;
                readonly thumbhash: string | null;
              } | {
                readonly __typename: "PublicImage";
                readonly __isPublicAndInternalImage: "PublicImage";
                readonly publicImageUrl: string;
              } | {
                readonly __typename: string;
                readonly __isPublicAndInternalImage: string;
              } | null;
              readonly name: string;
              readonly workStatus: EmployeeWorkStatus;
            } | null;
          } | {
            readonly __typename: "ScreenActor";
            readonly __isActor: "ScreenActor";
            readonly screen: {
              readonly id: string;
              readonly name: string;
            } | null;
          } | {
            readonly __typename: "UserActor";
            readonly __isActor: "UserActor";
            readonly storeUser: {
              readonly employee: {
                readonly id: string;
                readonly image: {
                  readonly __typename: "Image";
                  readonly __isPublicAndInternalImage: "Image";
                  readonly id: string;
                  readonly sizes: ReadonlyArray<{
                    readonly height: number;
                    readonly id: string;
                    readonly url: string;
                    readonly urlExpiresAt: string | null;
                    readonly width: number;
                  }>;
                  readonly thumbhash: string | null;
                } | {
                  readonly __typename: "PublicImage";
                  readonly __isPublicAndInternalImage: "PublicImage";
                  readonly publicImageUrl: string;
                } | {
                  readonly __typename: string;
                  readonly __isPublicAndInternalImage: string;
                } | null;
                readonly name: string;
                readonly workStatus: EmployeeWorkStatus;
              } | null;
              readonly id: string;
              readonly user: {
                readonly id: string;
                readonly name: string;
              };
            } | null;
          } | {
            readonly __typename: string;
            readonly __isActor: string;
          } | null;
          readonly resolvedAtDate: {
            readonly storeFormattedDate: string;
          } | null;
          readonly status: TodoStatus;
        }> | null;
        readonly timeToResolvedFormatted: string | null;
        readonly timeline: {
          readonly __id?: string;
          readonly edges: ReadonlyArray<{
            readonly cursor: string;
            readonly node: {
              readonly __typename: "TodoComment";
              readonly __isTodoTimelineItem: "TodoComment";
              readonly canDelete: boolean | null;
              readonly comment: string;
              readonly createdAtDate: {
                readonly storeFormattedDate: string;
              };
              readonly createdByActor: {
                readonly __typename: "ConnectActor";
                readonly __isActor: "ConnectActor";
                readonly employee: {
                  readonly __typename: "Employee";
                  readonly id: string;
                  readonly image: {
                    readonly __typename: "Image";
                    readonly __isPublicAndInternalImage: "Image";
                    readonly id: string;
                    readonly sizes: ReadonlyArray<{
                      readonly height: number;
                      readonly id: string;
                      readonly url: string;
                      readonly urlExpiresAt: string | null;
                      readonly width: number;
                    }>;
                    readonly thumbhash: string | null;
                  } | {
                    readonly __typename: "PublicImage";
                    readonly __isPublicAndInternalImage: "PublicImage";
                    readonly publicImageUrl: string;
                  } | {
                    readonly __typename: string;
                    readonly __isPublicAndInternalImage: string;
                  } | null;
                  readonly name: string;
                  readonly workStatus: EmployeeWorkStatus;
                } | null;
                readonly identifyingName: string | null;
              } | {
                readonly __typename: "GroupActor";
                readonly __isActor: "GroupActor";
                readonly employee: {
                  readonly __typename: "Employee";
                  readonly id: string;
                  readonly image: {
                    readonly __typename: "Image";
                    readonly __isPublicAndInternalImage: "Image";
                    readonly id: string;
                    readonly sizes: ReadonlyArray<{
                      readonly height: number;
                      readonly id: string;
                      readonly url: string;
                      readonly urlExpiresAt: string | null;
                      readonly width: number;
                    }>;
                    readonly thumbhash: string | null;
                  } | {
                    readonly __typename: "PublicImage";
                    readonly __isPublicAndInternalImage: "PublicImage";
                    readonly publicImageUrl: string;
                  } | {
                    readonly __typename: string;
                    readonly __isPublicAndInternalImage: string;
                  } | null;
                  readonly name: string;
                  readonly workStatus: EmployeeWorkStatus;
                } | null;
                readonly identifyingName: string | null;
                readonly user: {
                  readonly __typename: "User";
                  readonly id: string;
                } | null;
              } | {
                readonly __typename: "ScreenActor";
                readonly __isActor: "ScreenActor";
                readonly screen: {
                  readonly id: string;
                  readonly name: string;
                } | null;
              } | {
                readonly __typename: "UserActor";
                readonly __isActor: "UserActor";
                readonly storeUser: {
                  readonly employee: {
                    readonly id: string;
                    readonly image: {
                      readonly __typename: "Image";
                      readonly __isPublicAndInternalImage: "Image";
                      readonly id: string;
                      readonly sizes: ReadonlyArray<{
                        readonly height: number;
                        readonly id: string;
                        readonly url: string;
                        readonly urlExpiresAt: string | null;
                        readonly width: number;
                      }>;
                      readonly thumbhash: string | null;
                    } | {
                      readonly __typename: "PublicImage";
                      readonly __isPublicAndInternalImage: "PublicImage";
                      readonly publicImageUrl: string;
                    } | {
                      readonly __typename: string;
                      readonly __isPublicAndInternalImage: string;
                    } | null;
                    readonly name: string;
                    readonly workStatus: EmployeeWorkStatus;
                  } | null;
                  readonly id: string;
                  readonly user: {
                    readonly email: string;
                    readonly id: string;
                    readonly name: string;
                    readonly orgDescription: {
                      readonly orgIconUri: string | null;
                    } | null;
                  };
                } | null;
              } | {
                readonly __typename: string;
                readonly __isActor: string;
              } | null;
              readonly id: string;
            } | {
              readonly __typename: "TodoFeedback";
              readonly __isTodoTimelineItem: "TodoFeedback";
              readonly body: string | null;
              readonly contact: {
                readonly email: string | null;
                readonly name: string | null;
                readonly phoneNumber: string | null;
              } | null;
              readonly createdAtDate: {
                readonly storeFormattedDate: string;
              };
              readonly createdByActor: {
                readonly __typename: "ConnectActor";
                readonly __isActor: "ConnectActor";
                readonly employee: {
                  readonly __typename: "Employee";
                  readonly id: string;
                  readonly image: {
                    readonly __typename: "Image";
                    readonly __isPublicAndInternalImage: "Image";
                    readonly id: string;
                    readonly sizes: ReadonlyArray<{
                      readonly height: number;
                      readonly id: string;
                      readonly url: string;
                      readonly urlExpiresAt: string | null;
                      readonly width: number;
                    }>;
                    readonly thumbhash: string | null;
                  } | {
                    readonly __typename: "PublicImage";
                    readonly __isPublicAndInternalImage: "PublicImage";
                    readonly publicImageUrl: string;
                  } | {
                    readonly __typename: string;
                    readonly __isPublicAndInternalImage: string;
                  } | null;
                  readonly name: string;
                  readonly workStatus: EmployeeWorkStatus;
                } | null;
                readonly identifyingName: string | null;
              } | {
                readonly __typename: "GroupActor";
                readonly __isActor: "GroupActor";
                readonly employee: {
                  readonly __typename: "Employee";
                  readonly id: string;
                  readonly image: {
                    readonly __typename: "Image";
                    readonly __isPublicAndInternalImage: "Image";
                    readonly id: string;
                    readonly sizes: ReadonlyArray<{
                      readonly height: number;
                      readonly id: string;
                      readonly url: string;
                      readonly urlExpiresAt: string | null;
                      readonly width: number;
                    }>;
                    readonly thumbhash: string | null;
                  } | {
                    readonly __typename: "PublicImage";
                    readonly __isPublicAndInternalImage: "PublicImage";
                    readonly publicImageUrl: string;
                  } | {
                    readonly __typename: string;
                    readonly __isPublicAndInternalImage: string;
                  } | null;
                  readonly name: string;
                  readonly workStatus: EmployeeWorkStatus;
                } | null;
                readonly identifyingName: string | null;
                readonly user: {
                  readonly __typename: "User";
                  readonly id: string;
                } | null;
              } | {
                readonly __typename: "ScreenActor";
                readonly __isActor: "ScreenActor";
                readonly screen: {
                  readonly id: string;
                  readonly name: string;
                } | null;
              } | {
                readonly __typename: "UserActor";
                readonly __isActor: "UserActor";
                readonly storeUser: {
                  readonly employee: {
                    readonly id: string;
                    readonly image: {
                      readonly __typename: "Image";
                      readonly __isPublicAndInternalImage: "Image";
                      readonly id: string;
                      readonly sizes: ReadonlyArray<{
                        readonly height: number;
                        readonly id: string;
                        readonly url: string;
                        readonly urlExpiresAt: string | null;
                        readonly width: number;
                      }>;
                      readonly thumbhash: string | null;
                    } | {
                      readonly __typename: "PublicImage";
                      readonly __isPublicAndInternalImage: "PublicImage";
                      readonly publicImageUrl: string;
                    } | {
                      readonly __typename: string;
                      readonly __isPublicAndInternalImage: string;
                    } | null;
                    readonly name: string;
                    readonly workStatus: EmployeeWorkStatus;
                  } | null;
                  readonly id: string;
                  readonly user: {
                    readonly email: string;
                    readonly id: string;
                    readonly name: string;
                    readonly orgDescription: {
                      readonly orgIconUri: string | null;
                    } | null;
                  };
                } | null;
              } | {
                readonly __typename: string;
                readonly __isActor: string;
              } | null;
              readonly id: string;
              readonly title: string;
            } | {
              readonly __typename: "TodoTimelineUpdate";
              readonly __isTodoTimelineItem: "TodoTimelineUpdate";
              readonly createdAtDate: {
                readonly storeFormattedDate: string;
              };
              readonly createdByActor: {
                readonly __typename: "ConnectActor";
                readonly __isActor: "ConnectActor";
                readonly employee: {
                  readonly __typename: "Employee";
                  readonly id: string;
                  readonly image: {
                    readonly __typename: "Image";
                    readonly __isPublicAndInternalImage: "Image";
                    readonly id: string;
                    readonly sizes: ReadonlyArray<{
                      readonly height: number;
                      readonly id: string;
                      readonly url: string;
                      readonly urlExpiresAt: string | null;
                      readonly width: number;
                    }>;
                    readonly thumbhash: string | null;
                  } | {
                    readonly __typename: "PublicImage";
                    readonly __isPublicAndInternalImage: "PublicImage";
                    readonly publicImageUrl: string;
                  } | {
                    readonly __typename: string;
                    readonly __isPublicAndInternalImage: string;
                  } | null;
                  readonly name: string;
                  readonly workStatus: EmployeeWorkStatus;
                } | null;
                readonly identifyingName: string | null;
              } | {
                readonly __typename: "GroupActor";
                readonly __isActor: "GroupActor";
                readonly employee: {
                  readonly __typename: "Employee";
                  readonly id: string;
                  readonly image: {
                    readonly __typename: "Image";
                    readonly __isPublicAndInternalImage: "Image";
                    readonly id: string;
                    readonly sizes: ReadonlyArray<{
                      readonly height: number;
                      readonly id: string;
                      readonly url: string;
                      readonly urlExpiresAt: string | null;
                      readonly width: number;
                    }>;
                    readonly thumbhash: string | null;
                  } | {
                    readonly __typename: "PublicImage";
                    readonly __isPublicAndInternalImage: "PublicImage";
                    readonly publicImageUrl: string;
                  } | {
                    readonly __typename: string;
                    readonly __isPublicAndInternalImage: string;
                  } | null;
                  readonly name: string;
                  readonly workStatus: EmployeeWorkStatus;
                } | null;
                readonly identifyingName: string | null;
                readonly user: {
                  readonly __typename: "User";
                  readonly id: string;
                } | null;
              } | {
                readonly __typename: "ScreenActor";
                readonly __isActor: "ScreenActor";
                readonly screen: {
                  readonly id: string;
                  readonly name: string;
                } | null;
              } | {
                readonly __typename: "UserActor";
                readonly __isActor: "UserActor";
                readonly storeUser: {
                  readonly employee: {
                    readonly id: string;
                    readonly image: {
                      readonly __typename: "Image";
                      readonly __isPublicAndInternalImage: "Image";
                      readonly id: string;
                      readonly sizes: ReadonlyArray<{
                        readonly height: number;
                        readonly id: string;
                        readonly url: string;
                        readonly urlExpiresAt: string | null;
                        readonly width: number;
                      }>;
                      readonly thumbhash: string | null;
                    } | {
                      readonly __typename: "PublicImage";
                      readonly __isPublicAndInternalImage: "PublicImage";
                      readonly publicImageUrl: string;
                    } | {
                      readonly __typename: string;
                      readonly __isPublicAndInternalImage: string;
                    } | null;
                    readonly name: string;
                    readonly workStatus: EmployeeWorkStatus;
                  } | null;
                  readonly id: string;
                  readonly user: {
                    readonly email: string;
                    readonly id: string;
                    readonly name: string;
                    readonly orgDescription: {
                      readonly orgIconUri: string | null;
                    } | null;
                  };
                } | null;
              } | {
                readonly __typename: string;
                readonly __isActor: string;
              } | null;
              readonly events: ReadonlyArray<{
                readonly __typename: "TodoTimelineUpdateEventAssignedEmployees";
                readonly __isTodoTimelineUpdateEvent: "TodoTimelineUpdateEventAssignedEmployees";
                readonly addedAssignedEmployees: ReadonlyArray<{
                  readonly id: string;
                  readonly name: string;
                }>;
                readonly removedAssignedEmployees: ReadonlyArray<{
                  readonly id: string;
                  readonly name: string;
                }>;
              } | {
                readonly __typename: "TodoTimelineUpdateEventAssignedRoles";
                readonly __isTodoTimelineUpdateEvent: "TodoTimelineUpdateEventAssignedRoles";
                readonly addedAssignedRoles: ReadonlyArray<{
                  readonly id: string;
                  readonly name: string;
                }>;
                readonly removedAssignedRoles: ReadonlyArray<{
                  readonly id: string;
                  readonly name: string;
                }>;
              } | {
                readonly __typename: "TodoTimelineUpdateEventAssignedTeams";
                readonly __isTodoTimelineUpdateEvent: "TodoTimelineUpdateEventAssignedTeams";
                readonly addedAssignedTeams: ReadonlyArray<{
                  readonly color: string | null;
                  readonly icon: TeamIcon | null;
                  readonly id: string;
                  readonly name: string;
                }>;
                readonly removedAssignedTeams: ReadonlyArray<{
                  readonly color: string | null;
                  readonly icon: TeamIcon | null;
                  readonly id: string;
                  readonly name: string;
                }>;
              } | {
                readonly __typename: "TodoTimelineUpdateEventBody";
                readonly __isTodoTimelineUpdateEvent: "TodoTimelineUpdateEventBody";
                readonly newBody: string;
              } | {
                readonly __typename: "TodoTimelineUpdateEventCategory";
                readonly __isTodoTimelineUpdateEvent: "TodoTimelineUpdateEventCategory";
                readonly newCategory: {
                  readonly id: string;
                  readonly title: string;
                };
              } | {
                readonly __typename: "TodoTimelineUpdateEventExpireAt";
                readonly __isTodoTimelineUpdateEvent: "TodoTimelineUpdateEventExpireAt";
                readonly newExpireAt: {
                  readonly storeFormattedDate: string;
                };
              } | {
                readonly __typename: "TodoTimelineUpdateEventPriority";
                readonly __isTodoTimelineUpdateEvent: "TodoTimelineUpdateEventPriority";
                readonly newPriority: TodoPriority;
              } | {
                readonly __typename: "TodoTimelineUpdateEventStatus";
                readonly __isTodoTimelineUpdateEvent: "TodoTimelineUpdateEventStatus";
                readonly newStatus: TodoStatus;
              } | {
                readonly __typename: "TodoTimelineUpdateEventTags";
                readonly __isTodoTimelineUpdateEvent: "TodoTimelineUpdateEventTags";
                readonly addedTodoTags: ReadonlyArray<{
                  readonly color: string;
                  readonly id: string;
                  readonly title: string;
                }>;
                readonly removedTodoTags: ReadonlyArray<{
                  readonly color: string;
                  readonly id: string;
                  readonly title: string;
                }>;
              } | {
                readonly __typename: "TodoTimelineUpdateEventTitle";
                readonly __isTodoTimelineUpdateEvent: "TodoTimelineUpdateEventTitle";
                readonly newTitle: string;
              } | {
                readonly __typename: string;
                readonly __isTodoTimelineUpdateEvent: string;
              }>;
            } | {
              readonly __typename: string;
              readonly __isTodoTimelineItem: string;
            } | null;
          }>;
          readonly pageInfo: {
            readonly hasPreviousPage: boolean | null;
            readonly startCursor: string | null;
          };
        };
      };
    };
  } | null;
};
export type useTodoSetStatusMutation = {
  rawResponse: useTodoSetStatusMutation$rawResponse;
  response: useTodoSetStatusMutation$data;
  variables: useTodoSetStatusMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "employeeId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "newStatus"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "todoId"
},
v3 = [
  {
    "kind": "Variable",
    "name": "employeeId",
    "variableName": "employeeId"
  },
  {
    "kind": "Variable",
    "name": "todoId",
    "variableName": "todoId"
  }
],
v4 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "status",
        "variableName": "newStatus"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ordinal",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canChangeStatus",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "Todo",
  "kind": "LinkedField",
  "name": "parent",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    (v6/*: any*/),
    (v8/*: any*/)
  ],
  "storageKey": null
},
v10 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "TodoListItemCompletedInfo_todo"
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "StoreProduct",
  "kind": "LinkedField",
  "name": "linkedProducts",
  "plural": true,
  "selections": [
    (v5/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "numberOfPendingTodos",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timeToResolvedFormatted",
  "storageKey": null
},
v13 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "style",
        "value": "DEFAULT"
      }
    ],
    "kind": "ScalarField",
    "name": "storeFormattedDate",
    "storageKey": "storeFormattedDate(style:\"DEFAULT\")"
  }
],
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "StoreZonedDate",
  "kind": "LinkedField",
  "name": "resolvedAtDate",
  "plural": false,
  "selections": (v13/*: any*/),
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v16 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isActor"
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "image",
  "plural": false,
  "selections": [
    (v15/*: any*/),
    {
      "kind": "TypeDiscriminator",
      "abstractKey": "__isPublicAndInternalImage"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "publicImageUrl",
          "storageKey": null
        }
      ],
      "type": "PublicImage",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v5/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "thumbhash",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ImageSize",
          "kind": "LinkedField",
          "name": "sizes",
          "plural": true,
          "selections": [
            (v5/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "url",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "urlExpiresAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "height",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "width",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Image",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "workStatus",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "concreteType": "Employee",
  "kind": "LinkedField",
  "name": "employee",
  "plural": false,
  "selections": [
    (v17/*: any*/),
    (v18/*: any*/),
    (v19/*: any*/),
    (v5/*: any*/)
  ],
  "storageKey": null
},
v21 = [
  (v17/*: any*/),
  (v5/*: any*/)
],
v22 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "StorecastScreen",
      "kind": "LinkedField",
      "name": "screen",
      "plural": false,
      "selections": (v21/*: any*/),
      "storageKey": null
    }
  ],
  "type": "ScreenActor",
  "abstractKey": null
},
v23 = [
  (v20/*: any*/)
],
v24 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "lastChangedStatusByActor",
  "plural": false,
  "selections": [
    (v15/*: any*/),
    (v16/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "StoreUser",
          "kind": "LinkedField",
          "name": "storeUser",
          "plural": false,
          "selections": [
            (v20/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "User",
              "kind": "LinkedField",
              "name": "user",
              "plural": false,
              "selections": (v21/*: any*/),
              "storageKey": null
            },
            (v5/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "type": "UserActor",
      "abstractKey": null
    },
    (v22/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v23/*: any*/),
      "type": "GroupActor",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v23/*: any*/),
      "type": "ConnectActor",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "concreteType": "OrgDescription",
  "kind": "LinkedField",
  "name": "orgDescription",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "orgIconUri",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "concreteType": "Employee",
  "kind": "LinkedField",
  "name": "employee",
  "plural": false,
  "selections": [
    (v17/*: any*/),
    (v18/*: any*/),
    (v19/*: any*/),
    (v5/*: any*/),
    (v15/*: any*/)
  ],
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "identifyingName",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": [
    (v15/*: any*/),
    (v5/*: any*/)
  ],
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "createdByActor",
  "plural": false,
  "selections": [
    (v15/*: any*/),
    (v16/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "StoreUser",
          "kind": "LinkedField",
          "name": "storeUser",
          "plural": false,
          "selections": [
            (v20/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "User",
              "kind": "LinkedField",
              "name": "user",
              "plural": false,
              "selections": [
                (v17/*: any*/),
                (v5/*: any*/),
                (v25/*: any*/),
                (v26/*: any*/)
              ],
              "storageKey": null
            },
            (v5/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "type": "UserActor",
      "abstractKey": null
    },
    (v22/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v27/*: any*/),
        (v28/*: any*/),
        (v29/*: any*/)
      ],
      "type": "GroupActor",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v27/*: any*/),
        (v28/*: any*/)
      ],
      "type": "ConnectActor",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "concreteType": "StoreZonedDate",
  "kind": "LinkedField",
  "name": "createdAtDate",
  "plural": false,
  "selections": (v13/*: any*/),
  "storageKey": null
},
v32 = [
  {
    "kind": "Literal",
    "name": "last",
    "value": 100
  }
],
v33 = [
  (v5/*: any*/),
  (v17/*: any*/)
],
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v36 = [
  (v5/*: any*/),
  (v34/*: any*/),
  (v35/*: any*/)
],
v37 = [
  (v5/*: any*/),
  (v17/*: any*/),
  (v35/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "icon",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useTodoSetStatusMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "TodoMutation",
        "kind": "LinkedField",
        "name": "todo",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "UpdateTodoItemPayload",
            "kind": "LinkedField",
            "name": "updateTodoItemStatus",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Todo",
                "kind": "LinkedField",
                "name": "todo",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v9/*: any*/),
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Todo",
                    "kind": "LinkedField",
                    "name": "subTodos",
                    "plural": true,
                    "selections": [
                      (v6/*: any*/),
                      (v8/*: any*/),
                      (v10/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v11/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "lastChangedStatusByActor",
                    "plural": false,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "Avatar_actor"
                      }
                    ],
                    "storageKey": null
                  },
                  (v10/*: any*/),
                  (v12/*: any*/),
                  {
                    "kind": "Defer",
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "TodoEditTimeline_todo"
                      }
                    ]
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "useTodoSetStatusMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "TodoMutation",
        "kind": "LinkedField",
        "name": "todo",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "UpdateTodoItemPayload",
            "kind": "LinkedField",
            "name": "updateTodoItemStatus",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Todo",
                "kind": "LinkedField",
                "name": "todo",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v9/*: any*/),
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Todo",
                    "kind": "LinkedField",
                    "name": "subTodos",
                    "plural": true,
                    "selections": [
                      (v6/*: any*/),
                      (v8/*: any*/),
                      (v14/*: any*/),
                      (v24/*: any*/),
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v11/*: any*/),
                  (v24/*: any*/),
                  (v14/*: any*/),
                  (v12/*: any*/),
                  {
                    "if": null,
                    "kind": "Defer",
                    "label": "useTodoSetStatusMutation$defer$TodoEditTimeline_todo",
                    "selections": [
                      (v30/*: any*/),
                      (v31/*: any*/),
                      {
                        "alias": null,
                        "args": (v32/*: any*/),
                        "concreteType": "TodoTimelineConnection",
                        "kind": "LinkedField",
                        "name": "timeline",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TodoTimelineEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v15/*: any*/),
                                  {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isTodoTimelineItem"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "canDelete",
                                        "storageKey": null
                                      },
                                      (v5/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "comment",
                                        "storageKey": null
                                      },
                                      (v30/*: any*/),
                                      (v31/*: any*/)
                                    ],
                                    "type": "TodoComment",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "events",
                                        "plural": true,
                                        "selections": [
                                          (v15/*: any*/),
                                          {
                                            "kind": "TypeDiscriminator",
                                            "abstractKey": "__isTodoTimelineUpdateEvent"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "Employee",
                                                "kind": "LinkedField",
                                                "name": "addedAssignedEmployees",
                                                "plural": true,
                                                "selections": (v33/*: any*/),
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "Employee",
                                                "kind": "LinkedField",
                                                "name": "removedAssignedEmployees",
                                                "plural": true,
                                                "selections": (v33/*: any*/),
                                                "storageKey": null
                                              }
                                            ],
                                            "type": "TodoTimelineUpdateEventAssignedEmployees",
                                            "abstractKey": null
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "newTitle",
                                                "storageKey": null
                                              }
                                            ],
                                            "type": "TodoTimelineUpdateEventTitle",
                                            "abstractKey": null
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "newBody",
                                                "storageKey": null
                                              }
                                            ],
                                            "type": "TodoTimelineUpdateEventBody",
                                            "abstractKey": null
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "newStatus",
                                                "storageKey": null
                                              }
                                            ],
                                            "type": "TodoTimelineUpdateEventStatus",
                                            "abstractKey": null
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "newPriority",
                                                "storageKey": null
                                              }
                                            ],
                                            "type": "TodoTimelineUpdateEventPriority",
                                            "abstractKey": null
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "TodoCategory",
                                                "kind": "LinkedField",
                                                "name": "newCategory",
                                                "plural": false,
                                                "selections": [
                                                  (v34/*: any*/),
                                                  (v5/*: any*/)
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "type": "TodoTimelineUpdateEventCategory",
                                            "abstractKey": null
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "StoreZonedDate",
                                                "kind": "LinkedField",
                                                "name": "newExpireAt",
                                                "plural": false,
                                                "selections": (v13/*: any*/),
                                                "storageKey": null
                                              }
                                            ],
                                            "type": "TodoTimelineUpdateEventExpireAt",
                                            "abstractKey": null
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "TodoCategoryTag",
                                                "kind": "LinkedField",
                                                "name": "addedTodoTags",
                                                "plural": true,
                                                "selections": (v36/*: any*/),
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "TodoCategoryTag",
                                                "kind": "LinkedField",
                                                "name": "removedTodoTags",
                                                "plural": true,
                                                "selections": (v36/*: any*/),
                                                "storageKey": null
                                              }
                                            ],
                                            "type": "TodoTimelineUpdateEventTags",
                                            "abstractKey": null
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "Team",
                                                "kind": "LinkedField",
                                                "name": "addedAssignedTeams",
                                                "plural": true,
                                                "selections": (v37/*: any*/),
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "Team",
                                                "kind": "LinkedField",
                                                "name": "removedAssignedTeams",
                                                "plural": true,
                                                "selections": (v37/*: any*/),
                                                "storageKey": null
                                              }
                                            ],
                                            "type": "TodoTimelineUpdateEventAssignedTeams",
                                            "abstractKey": null
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "EmployeeRole",
                                                "kind": "LinkedField",
                                                "name": "addedAssignedRoles",
                                                "plural": true,
                                                "selections": (v33/*: any*/),
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "EmployeeRole",
                                                "kind": "LinkedField",
                                                "name": "removedAssignedRoles",
                                                "plural": true,
                                                "selections": (v33/*: any*/),
                                                "storageKey": null
                                              }
                                            ],
                                            "type": "TodoTimelineUpdateEventAssignedRoles",
                                            "abstractKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      (v31/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "createdByActor",
                                        "plural": false,
                                        "selections": [
                                          (v15/*: any*/),
                                          (v16/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "StoreUser",
                                                "kind": "LinkedField",
                                                "name": "storeUser",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Employee",
                                                    "kind": "LinkedField",
                                                    "name": "employee",
                                                    "plural": false,
                                                    "selections": [
                                                      (v17/*: any*/),
                                                      (v5/*: any*/),
                                                      (v18/*: any*/),
                                                      (v19/*: any*/)
                                                    ],
                                                    "storageKey": null
                                                  },
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "User",
                                                    "kind": "LinkedField",
                                                    "name": "user",
                                                    "plural": false,
                                                    "selections": [
                                                      (v17/*: any*/),
                                                      (v25/*: any*/),
                                                      (v5/*: any*/),
                                                      (v26/*: any*/)
                                                    ],
                                                    "storageKey": null
                                                  },
                                                  (v5/*: any*/)
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "type": "UserActor",
                                            "abstractKey": null
                                          },
                                          (v22/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "Employee",
                                                "kind": "LinkedField",
                                                "name": "employee",
                                                "plural": false,
                                                "selections": [
                                                  (v17/*: any*/),
                                                  (v5/*: any*/),
                                                  (v15/*: any*/),
                                                  (v18/*: any*/),
                                                  (v19/*: any*/)
                                                ],
                                                "storageKey": null
                                              },
                                              (v28/*: any*/),
                                              (v29/*: any*/)
                                            ],
                                            "type": "GroupActor",
                                            "abstractKey": null
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v28/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "Employee",
                                                "kind": "LinkedField",
                                                "name": "employee",
                                                "plural": false,
                                                "selections": [
                                                  (v17/*: any*/),
                                                  (v5/*: any*/),
                                                  (v18/*: any*/),
                                                  (v19/*: any*/),
                                                  (v15/*: any*/)
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "type": "ConnectActor",
                                            "abstractKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "TodoTimelineUpdate",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v34/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "body",
                                        "storageKey": null
                                      },
                                      (v30/*: any*/),
                                      (v31/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "TodoContact",
                                        "kind": "LinkedField",
                                        "name": "contact",
                                        "plural": false,
                                        "selections": [
                                          (v25/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "phoneNumber",
                                            "storageKey": null
                                          },
                                          (v17/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v5/*: any*/)
                                    ],
                                    "type": "TodoFeedback",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "cursor",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "hasPreviousPage",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "startCursor",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "kind": "ClientExtension",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "__id",
                                "storageKey": null
                              }
                            ]
                          }
                        ],
                        "storageKey": "timeline(last:100)"
                      },
                      {
                        "alias": null,
                        "args": (v32/*: any*/),
                        "filters": null,
                        "handle": "connection",
                        "key": "TodoEditTimeline__timeline",
                        "kind": "LinkedHandle",
                        "name": "timeline"
                      },
                      (v5/*: any*/)
                    ]
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6e469eb44ffec95b30443d560e22e3fb",
    "id": null,
    "metadata": {},
    "name": "useTodoSetStatusMutation",
    "operationKind": "mutation",
    "text": "mutation useTodoSetStatusMutation(\n  $todoId: ID!\n  $newStatus: TodoStatus!\n  $employeeId: ID\n) {\n  todo(todoId: $todoId, employeeId: $employeeId) {\n    updateTodoItemStatus(input: {status: $newStatus}) {\n      todo {\n        id\n        status\n        ordinal\n        parent {\n          id\n          status\n          canChangeStatus\n        }\n        canChangeStatus\n        subTodos {\n          status\n          canChangeStatus\n          ...TodoListItemCompletedInfo_todo\n          id\n        }\n        linkedProducts {\n          id\n          numberOfPendingTodos\n        }\n        lastChangedStatusByActor {\n          __typename\n          ...Avatar_actor\n        }\n        ...TodoListItemCompletedInfo_todo\n        timeToResolvedFormatted\n        ...TodoEditTimeline_todo @defer(label: \"useTodoSetStatusMutation$defer$TodoEditTimeline_todo\")\n      }\n    }\n  }\n}\n\nfragment AHTeamIcon on Team {\n  icon\n}\n\nfragment Avatar_actor on Actor {\n  __isActor: __typename\n  ... on UserActor {\n    __typename\n    storeUser {\n      employee {\n        name\n        ...Avatar_employee\n        id\n      }\n      user {\n        name\n        ...Avatar_user\n        id\n      }\n      id\n    }\n  }\n  ... on ScreenActor {\n    __typename\n    screen {\n      name\n      id\n    }\n  }\n  ... on GroupActor {\n    __typename\n    ...Avatar_groupActor\n  }\n  ... on ConnectActor {\n    __typename\n    ...Avatar_connectActor\n  }\n}\n\nfragment Avatar_connectActor on ConnectActor {\n  employee {\n    name\n    ...Avatar_employee\n    id\n  }\n}\n\nfragment Avatar_employee on Employee {\n  image {\n    __typename\n    ...ImagePublicOrPrivate_image\n    ... on Image {\n      id\n    }\n  }\n  workStatus\n  name\n}\n\nfragment Avatar_groupActor on GroupActor {\n  employee {\n    name\n    ...Avatar_employee\n    id\n  }\n}\n\nfragment Avatar_user on User {\n  name\n}\n\nfragment ImagePublicOrPrivate_image on PublicAndInternalImage {\n  __isPublicAndInternalImage: __typename\n  ... on PublicImage {\n    ...ImagePublic_image\n    __typename\n  }\n  ... on Image {\n    id\n    ...Image_image\n    __typename\n  }\n}\n\nfragment ImagePublic_image on PublicImage {\n  publicImageUrl\n}\n\nfragment Image_image on Image {\n  id\n  thumbhash\n  sizes {\n    id\n    url\n    urlExpiresAt\n    height\n    width\n  }\n}\n\nfragment SignedActorBadge_actor on Actor {\n  __isActor: __typename\n  ... on UserActor {\n    storeUser {\n      user {\n        orgDescription {\n          orgIconUri\n        }\n        id\n      }\n      id\n    }\n    __typename\n  }\n  ... on ConnectActor {\n    employee {\n      __typename\n      id\n    }\n    __typename\n  }\n  ... on GroupActor {\n    __typename\n    employee {\n      __typename\n      id\n    }\n    user {\n      __typename\n      id\n    }\n  }\n}\n\nfragment SignedActorCompactBadge_actor on Actor {\n  __isActor: __typename\n  ... on UserActor {\n    storeUser {\n      user {\n        orgDescription {\n          orgIconUri\n        }\n        id\n      }\n      id\n    }\n    __typename\n  }\n  ... on GroupActor {\n    __typename\n    employee {\n      __typename\n      id\n    }\n    user {\n      __typename\n      id\n    }\n  }\n  ... on ScreenActor {\n    __typename\n  }\n  ... on ConnectActor {\n    __typename\n  }\n}\n\nfragment SignedActorCompact_actor on Actor {\n  __isActor: __typename\n  ...SignedActorText_actor\n  ...SignedActorCompactBadge_actor\n}\n\nfragment SignedActorText_actor on Actor {\n  __isActor: __typename\n  ... on UserActor {\n    __typename\n    storeUser {\n      employee {\n        name\n        id\n      }\n      user {\n        name\n        email\n        id\n      }\n      id\n    }\n  }\n  ... on ScreenActor {\n    __typename\n    screen {\n      name\n      id\n    }\n  }\n  ... on GroupActor {\n    __typename\n    employee {\n      name\n      id\n    }\n    identifyingName\n  }\n  ... on ConnectActor {\n    __typename\n    identifyingName\n    employee {\n      name\n      id\n    }\n  }\n}\n\nfragment SignedActor_actor on Actor {\n  __isActor: __typename\n  ...Avatar_actor\n  ...SignedActorText_actor\n  ...SignedActorBadge_actor\n}\n\nfragment StoreFormattedDate on StoreZonedDate {\n  storeFormattedDate(style: DEFAULT)\n}\n\nfragment TodoEditTimeline_todo on Todo {\n  ...TodoTimelineUpdateEventCreated_todo\n  timeline(last: 100) {\n    edges {\n      node {\n        __typename\n        ... on TodoComment {\n          canDelete\n          id\n        }\n        ...TodoTimeline_item\n        ... on TodoFeedback {\n          id\n        }\n      }\n      cursor\n    }\n    pageInfo {\n      hasPreviousPage\n      startCursor\n    }\n  }\n  id\n}\n\nfragment TodoListItemCompletedInfo_todo on Todo {\n  resolvedAtDate {\n    ...StoreFormattedDate\n  }\n  lastChangedStatusByActor {\n    __typename\n    ...Avatar_actor\n  }\n}\n\nfragment TodoTimelineComment_todoComment on TodoComment {\n  comment\n  id\n  createdByActor {\n    __typename\n    ...SignedActor_actor\n  }\n  createdAtDate {\n    ...StoreFormattedDate\n  }\n}\n\nfragment TodoTimelineFeedback_feedback on TodoFeedback {\n  title\n  body\n  createdByActor {\n    __typename\n    ...SignedActor_actor\n  }\n  createdAtDate {\n    ...StoreFormattedDate\n  }\n  contact {\n    email\n    phoneNumber\n    name\n  }\n}\n\nfragment TodoTimelineUpdateEventBody_event on TodoTimelineUpdateEvent {\n  __isTodoTimelineUpdateEvent: __typename\n  __typename\n  ... on TodoTimelineUpdateEventAssignedEmployees {\n    addedAssignedEmployees {\n      id\n      ...TodoTimelineUpdateEventEmployee_employee\n    }\n    removedAssignedEmployees {\n      id\n      ...TodoTimelineUpdateEventEmployee_employee\n    }\n    __typename\n  }\n  ... on TodoTimelineUpdateEventTitle {\n    newTitle\n    __typename\n  }\n  ... on TodoTimelineUpdateEventBody {\n    newBody\n    __typename\n  }\n  ... on TodoTimelineUpdateEventStatus {\n    newStatus\n    __typename\n  }\n  ... on TodoTimelineUpdateEventPriority {\n    newPriority\n    __typename\n  }\n  ... on TodoTimelineUpdateEventCategory {\n    newCategory {\n      title\n      id\n    }\n    __typename\n  }\n  ... on TodoTimelineUpdateEventExpireAt {\n    __typename\n    newExpireAt {\n      ...StoreFormattedDate\n    }\n  }\n  ... on TodoTimelineUpdateEventTags {\n    addedTodoTags {\n      id\n      ...TodoTimelineUpdateEventTag_tag\n    }\n    removedTodoTags {\n      id\n      ...TodoTimelineUpdateEventTag_tag\n    }\n    __typename\n  }\n  ... on TodoTimelineUpdateEventAssignedTeams {\n    addedAssignedTeams {\n      id\n      ...TodoTimelineUpdateEventTeam_team\n    }\n    removedAssignedTeams {\n      id\n      ...TodoTimelineUpdateEventTeam_team\n    }\n    __typename\n  }\n  ... on TodoTimelineUpdateEventAssignedRoles {\n    addedAssignedRoles {\n      id\n      ...TodoTimelineUpdateEventRole_role\n    }\n    removedAssignedRoles {\n      id\n      ...TodoTimelineUpdateEventRole_role\n    }\n    __typename\n  }\n}\n\nfragment TodoTimelineUpdateEventCreated_todo on Todo {\n  createdByActor {\n    __typename\n    ...SignedActor_actor\n  }\n  createdAtDate {\n    ...StoreFormattedDate\n  }\n}\n\nfragment TodoTimelineUpdateEventEmployee_employee on Employee {\n  name\n}\n\nfragment TodoTimelineUpdateEventIcon_event on TodoTimelineUpdateEvent {\n  __isTodoTimelineUpdateEvent: __typename\n  __typename\n  ... on TodoTimelineUpdateEventAssignedEmployees {\n    __typename\n  }\n  ... on TodoTimelineUpdateEventTitle {\n    __typename\n  }\n  ... on TodoTimelineUpdateEventBody {\n    __typename\n  }\n  ... on TodoTimelineUpdateEventStatus {\n    newStatus\n    __typename\n  }\n  ... on TodoTimelineUpdateEventPriority {\n    newPriority\n    __typename\n  }\n  ... on TodoTimelineUpdateEventCategory {\n    __typename\n  }\n  ... on TodoTimelineUpdateEventExpireAt {\n    __typename\n  }\n  ... on TodoTimelineUpdateEventTags {\n    __typename\n  }\n  ... on TodoTimelineUpdateEventAssignedTeams {\n    __typename\n  }\n  ... on TodoTimelineUpdateEventAssignedRoles {\n    __typename\n  }\n}\n\nfragment TodoTimelineUpdateEventRole_role on EmployeeRole {\n  name\n}\n\nfragment TodoTimelineUpdateEventTag_tag on TodoCategoryTag {\n  title\n  color\n}\n\nfragment TodoTimelineUpdateEventTeam_team on Team {\n  name\n  color\n  icon\n  ...AHTeamIcon\n}\n\nfragment TodoTimelineUpdateEvent_event on TodoTimelineUpdateEvent {\n  __isTodoTimelineUpdateEvent: __typename\n  __typename\n  ...TodoTimelineUpdateEventIcon_event\n  ...TodoTimelineUpdateEventBody_event\n  ... on TodoTimelineUpdateEventStatus {\n    newStatus\n  }\n}\n\nfragment TodoTimelineUpdateEvent_timelineItem on TodoTimelineUpdate {\n  createdAtDate {\n    ...StoreFormattedDate\n  }\n  createdByActor {\n    __typename\n    ...SignedActorCompact_actor\n    ...SignedActor_actor\n  }\n}\n\nfragment TodoTimelineUpdate_todoTimelineUpdate on TodoTimelineUpdate {\n  events {\n    __typename\n    ...TodoTimelineUpdateEvent_event\n  }\n  ...TodoTimelineUpdateEvent_timelineItem\n}\n\nfragment TodoTimeline_item on TodoTimelineItem {\n  __isTodoTimelineItem: __typename\n  ... on TodoComment {\n    ...TodoTimelineComment_todoComment\n    __typename\n  }\n  ... on TodoTimelineUpdate {\n    __typename\n    ...TodoTimelineUpdate_todoTimelineUpdate\n  }\n  ... on TodoFeedback {\n    __typename\n    ...TodoTimelineFeedback_feedback\n  }\n}\n"
  }
};
})();

(node as any).hash = "f04e184fbb52b47a2590b84c6a5a65d9";

export default node;
